import React from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import {
  changeInterestAnswer,
  getInterestQuestion,
  getInterest,
  finishInterest,
} from '../../../../ducks/respondent'
import styles from './InterestQuestion.module.scss'
import { Tile } from 'components/shared/Tile/Tile'
import SwipePage, { Slider } from 'components/common/SwipePage'
import {
  nextPage,
  previousPage,
  nextUnanswered,
  getQuizPage,
  getLocation,
} from 'ducks/router'
import { QuestionContainer } from 'components/shared/QuestionContainer/QuestionContainer'

const InterestQuestion = ({
  question,
  finished,
  totalQuestions,
  pageFromUrl,
  answered,
  nextPage,
  previousPage,
  nextUnanswered,
  questions,
  finishInterest,
  changeInterestAnswer,
  prompt,
  label = 'which number?',
  scale = { 1: 'one', 2: 'two', 3: 'three' },
  value = null,
  reversed,
}) => {
  const changeValue = value => {
    changeInterestAnswer({ key: question, value })
    value && nextUnanswered()
  }

  if (!questions) {
    return null
  }

  const questionIndex = pageFromUrl + 1

  const tiles = R.pipe(
    R.mapObjIndexed((label, val) => (
      <Tile
        key={val}
        label={label}
        onClick={ev => {
          ev.preventDefault()
          ev.stopPropagation()
          changeValue(val == value ? null : val)
        }}
        selected={val === value}
      />
    )),
    R.values,
  )(scale)

  return (
    <QuestionContainer
      {...{
        questionIndex,
        totalQuestions,
        finished,
        previousPage,
        answered,
        nextUnanswered,
        nextPage,
      }}
      finishTest={() => finishInterest()}
      collapse
    >
      <Slider page={prompt} reversed={reversed} slideSpeed={400}>
        <div className={styles.prompt}>{prompt}</div>
      </Slider>

      <SwipePage slideSpeed={400}>
        <div className={styles.swipePage}>
          <div className={styles.statement}>
            {label.charAt(0).toUpperCase() + label.slice(1)}
          </div>
          <div className={styles.tiles}>{tiles}</div>
        </div>
      </SwipePage>
    </QuestionContainer>
  )
}

const mapStateToProps = (state, { page }) => {
  const questionProps = getInterestQuestion(R.isNil(page) ? null : { page })(
    state,
  )
  const { totalQuestions, totalAnswers } = getInterest(state)
  const finished = totalQuestions - totalAnswers === 0
  const pageFromUrl = getQuizPage(state).page

  return {
    questions: state.respondent.interest.questions,
    finished,
    totalQuestions,
    totalAnswers,
    pageFromUrl,
    answered: questionProps.value != null,
    reversed: getQuizPage(state).reversed,
    ...questionProps,
  }
}

const mapDispatchToProps = {
  changeInterestAnswer,
  nextPage,
  previousPage,
  nextUnanswered,
  finishInterest,
}

export default connect(mapStateToProps, mapDispatchToProps)(InterestQuestion)
